import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-opacity",
  templateUrl: "./med-icon-opacity.component.html",
})
export class MedIconOpacityComponent extends SvgMixinComponent {}
